export const MESSAGES_UPDATED = 'MESSAGES_UPDATED';
export const MESSAGES_HARD_DELETED = 'MESSAGES_HARD_DELETED';